/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { Button, Popover, PopoverBody } from 'reactstrap';
import { INSERT_VARIABLE_COMMAND } from './index';
import { VariableKey } from '../../types';
import { VARIABLE_DEFINITIONS } from '../../constants';
import { useToggle } from '@hooks/useToggle';

const variableDropdownId = 'variable-dropdown';

export const VariableToolbarMenu = () => {
  const [editor] = useLexicalComposerContext();
  const [popoverOpen, toggle] = useToggle(false);

  const handleVariableInsert = (variableKey: VariableKey) => {
    editor.dispatchCommand(INSERT_VARIABLE_COMMAND, variableKey);
    toggle();
  };

  return (
    <>
      <Button
        id={variableDropdownId}
        outline={false}
        color='transparent'
        onMouseDown={(e) => e.preventDefault()}
        onClick={toggle}
        className={`${popoverOpen ? 'active' : ''} flex-shrink-0 border-0`}
        size='sm'
        title='Insert Variable'
        aria-label='Insert variable'
      >
        <i className={`fal fa-brackets-curly ${popoverOpen ? 'text-ThemeTextDark' : 'text-ThemeIconSecondary'}`} />
        <i className={`ms-1 fal fa-caret-down ${popoverOpen ? 'text-ThemeTextDark' : 'text-ThemeIconSecondary'}`} />
      </Button>
      <Popover
        isOpen={popoverOpen}
        toggle={toggle}
        placement='bottom'
        target={variableDropdownId}
        trigger='legacy'
        hideArrow
        delay={0}
      >
        <PopoverBody className='p-0' style={{ minWidth: '220px' }}>
          <div className='list-group list-group-flush'>
            {VARIABLE_DEFINITIONS.map((variable) => (
              <button
                key={variable.key}
                type='button'
                className='list-group-item list-group-item-action d-flex align-items-center py-2 px-3'
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => handleVariableInsert(variable.key)}
              >
                <i className={`fa-light ${variable.icon} me-2`} style={{ width: '20px' }}></i>
                <span>{variable.label}</span>
              </button>
            ))}
          </div>
        </PopoverBody>
      </Popover>
    </>
  );
};
